// extracted by mini-css-extract-plugin
module.exports = {"exampleCode":"widget-demo--exampleCode--4s2Hd"};